export const CreativeDSPConstant = {

    EMPTY_DSPS_FOR_ACCOUNT: "removing all dsps for the account",
    GET_DSPS_FOR_ACCOUNT_INIT: "getting dsps for the account init",
    GET_DSPS_FOR_ACCOUNT_SUCCESS: "getting dsps for the account success",
    GET_DSPS_FOR_ACCOUNT_ERROR: "getting dsps for the account error",
};
